export default __webpack_public_path__ + "static/media/contacttop.9915ef54.png";